<template>
  <b-container>
    <b-form v-on:submit.prevent enctype="multipart/form-data">
      <b-row>
        <b-col cols="12">
          <b-card>
            <b-row>
              <b-col class="text-left mb-2">
                <b-badge :variant="statusVariant(this.detail.status)">
                  <span v-if="this.detail.status === 0">{{
                    detail.status_name
                  }}</span>
                  <span v-else-if="this.detail.status === 1">{{
                    detail.status_name
                  }}</span>
                  <span v-else-if="this.detail.status === 2">{{
                    detail.status_name
                  }}</span>
                  <span v-else-if="this.detail.status === 3">{{
                    detail.status_name
                  }}</span>
                  <span v-else-if="this.detail.status === 4">{{
                    detail.status_name
                  }}</span>
                </b-badge>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col md="2"> Code <span class="float-right">:</span> </b-col>
              <b-col md="10" class="text-primary font-weight-bold">
                {{ detail.code }}
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col md="2"> Origin <span class="float-right">:</span> </b-col>
              <b-col md="10" class="text-primary font-weight-bold">
                {{ detail.origin }}
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col md="2">
                Destination <span class="float-right">:</span>
              </b-col>
              <b-col md="10" class="text-primary font-weight-bold">
                {{ detail.destination }}
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col md="2">
                Description <span class="float-right">:</span>
              </b-col>
              <b-col md="10" class="text-primary font-weight-bold">
                {{ detail.description }}
              </b-col>
            </b-row>
            <b-row class="mb-1" v-if="detail.status === 3">
              <b-col md="2">
                Reject Reason <span class="float-right">:</span>
              </b-col>
              <b-col md="10" class="text-primary font-weight-bold">
                {{ detail.reject_reason }}
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col cols="12">
          <b-card>
            <b-row>
              <b-col>
                <label for="items" class="text-primary font-weight-bolder mb-1"
                  >Items</label
                >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  v-b-modal.modal-add
                  class="float-right mb-2"
                  >Add Item
                </b-button>
              </b-col>
            </b-row>
            <b-modal
              id="modal-add"
              ref="modal-add"
              centered
              title="Add Item"
              hide-footer
            >
              <b-row>
                <b-col cols="12">
                  <b-form-group label="Product" label-for="product">
                    <v-select
                      id="product"
                      v-model="form2.selectedProduct"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="text"
                      :options="form2.optionsProduct"
                      placeholder="Select 1 Product"
                    >
                      <template #search="{ attributes, events }">
                        <input
                          class="vs__search"
                          :required="!form2.selectedProduct"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-select>
                    <!-- Selected: <strong>{{ form2.selectedProduct }}</strong> -->
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group label="Qty" label-for="qty">
                    <b-form-input
                      id="qty"
                      placeholder="Qty"
                      v-model="form2.qty"
                      type="number"
                      required
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    class="my-1"
                    block
                    @click="addTransferItem()"
                  >
                    Add Item
                  </b-button>
                </b-col>
              </b-row>
            </b-modal>

            <b-row>
              <b-col md="12">
                <!-- table -->
                <vue-good-table
                  :columns="columns"
                  :rows="rows"
                  :rtl="direction"
                  :search-options="{
                    enabled: true,
                    externalQuery: searchTerm,
                  }"
                  :select-options="{
                    enabled: false,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                    disableSelectInfo: true, // disable the select info panel on top
                    selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                  }"
                  :pagination-options="{
                    enabled: true,
                    perPage: pageLength,
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <!-- Column: Name -->
                    <span
                      v-if="props.column.field === 'name'"
                      class="text-nowrap"
                    >
                      <!-- <b-avatar
                                            :src="props.row.avatar"
                                            class="mx-1"
                                        /> -->
                      <span class="text-nowrap">{{ props.row.name }}</span>
                    </span>

                    <!-- Column: Image -->
                    <span
                      v-else-if="props.column.field === 'image'"
                      class="text-nowrap"
                    >
                      <span class="text-nowrap"
                        ><img :src="props.row.image" alt="items" width="50"
                      /></span>
                    </span>

                    <!-- Column: Price -->
                    <span
                      v-else-if="props.column.field === 'price'"
                      class="text-nowrap"
                    >
                      <span class="text-nowrap">Rp {{ props.row.price }}</span>
                    </span>

                    <!-- Column: Status -->
                    <span v-else-if="props.column.field === 'status'">
                      <b-badge :variant="statusVariant(props.row.status)">
                        <span v-if="props.row.status === 1">Active</span>
                        <span v-else>Non-Active</span>
                      </b-badge>
                    </span>

                    <!-- Column: Action -->
                    <span v-else-if="props.column.field === 'action'">
                      <span>
                        <b-dropdown
                          variant="link"
                          toggle-class="text-decoration-none"
                          no-caret
                        >
                          <template v-slot:button-content>
                            <feather-icon
                              icon="MoreVerticalIcon"
                              size="16"
                              class="text-body align-middle mr-25"
                            />
                          </template>
                          <b-dropdown-item
                            v-b-modal.modal-detail
                            @click="
                              trigger(
                                props.row.id,
                                props.row.image,
                                props.row.code,
                                props.row.name,
                                props.row.unit_name,
                                props.row.qty,
                                props.row.item_id
                              )
                            "
                            v-if="
                              permissions.includes(
                                'warehouse-transfer-item-detail'
                              )
                            "
                          >
                            <feather-icon icon="Edit2Icon" class="mr-50" />
                            <span>Detail</span>
                          </b-dropdown-item>
                          <b-dropdown-item
                            @click="deleteTransferItem(props.row.id)"
                            v-if="
                              permissions.includes(
                                'warehouse-transfer-item-delete'
                              )
                            "
                          >
                            <feather-icon icon="TrashIcon" class="mr-50" />
                            <span>Delete</span>
                          </b-dropdown-item>
                        </b-dropdown>
                      </span>
                    </span>

                    <!-- Column: Common -->
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </template>

                  <!-- pagination -->
                  <template slot="pagination-bottom" slot-scope="props">
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Showing 1 to </span>
                        <b-form-select
                          v-model="pageLength"
                          :options="['3', '5', '10']"
                          class="mx-1"
                          @input="
                            (value) =>
                              props.perPageChanged({ currentPerPage: value })
                          "
                        />
                        <span class="text-nowrap">
                          of {{ props.total }} entries
                        </span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="props.total"
                          :per-page="pageLength"
                          first-number
                          last-number
                          align="right"
                          prev-class="prev-item"
                          next-class="next-item"
                          class="mt-1 mb-0"
                          @input="
                            (value) => props.pageChanged({ currentPage: value })
                          "
                        >
                          <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                          </template>
                          <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                          </template>
                        </b-pagination>
                      </div>
                    </div>
                  </template>
                </vue-good-table>
                <b-modal
                  id="modal-detail"
                  title="Detail Item"
                  ok-title="Detail"
                  cancel-variant="outline-secondary"
                  hide-footer
                >
                  <validation-observer ref="loginValidation">
                    <b-form ref="form" @submit.prevent>
                      <img fluid :src="image" width="200" class="mb-1" />
                      <b-row class="mb-1">
                        <b-col md="3">
                          Code <span class="float-right">:</span>
                        </b-col>
                        <b-col md="9">
                          {{ code }}
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="3">
                          Name <span class="float-right">:</span>
                        </b-col>
                        <b-col md="9">
                          {{ name }}
                        </b-col>
                      </b-row>
                      <b-row class="mb-1">
                        <b-col md="3">
                          Unit <span class="float-right">:</span>
                        </b-col>
                        <b-col md="9">
                          {{ unit_name }}
                        </b-col>
                      </b-row>
                      <b-form-group
                        :state="errors"
                        label="Qty"
                        label-for="qty"
                        invalid-feedback="Qty required"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="qty"
                          rules="required"
                        >
                          <b-form-input
                            id="qty"
                            name="qty"
                            type="number"
                            v-model="form.qty"
                            :state="errors.length > 0 ? false : null"
                            placeholder="Qty"
                            required="required"
                          />
                          <small class="text-danger">{{
                            errors[0] || errMessage
                          }}</small>
                        </validation-provider>
                      </b-form-group>
                      <b-row>
                        <b-col>
                          <b-button
                            class="my-1"
                            type="submit"
                            variant="success"
                            block
                            @click="updateTransferItem()"
                          >
                            Update
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-form>
                  </validation-observer>
                </b-modal>
                <!-- end modal -->
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <!-- submit -->
        <b-col
          cols="12"
          v-if="
            permissions.includes('warehouse-transfer-update') &&
            detail.status === 0
          "
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            class="mr-1"
            block
            @click="submit()"
          >
            Submit
          </b-button>
        </b-col>
        <!-- approval -->
        <b-col
          cols="12"
          v-if="
            permissions.includes('warehouse-transfer-confirm') &&
            detail.status === 1
          "
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            class="mr-1"
            block
            @click="confirm()"
          >
            Confirm
          </b-button>
        </b-col>
        <b-col
          cols="12"
          v-if="
            permissions.includes('warehouse-transfer-reject') &&
            detail.status === 1
          "
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="danger"
            class="mr-1"
            block
            v-b-modal.modal-reject
          >
            Reject
          </b-button>
        </b-col>
      </b-row>
      <b-modal
        id="modal-reject"
        title="Reject Form"
        ok-title="Reject"
        cancel-variant="outline-secondary"
        hide-footer
      >
        <validation-observer ref="loginValidation">
          <b-form ref="form" @submit.prevent>
            <b-form-group
              :state="errors"
              label="Reject Reason"
              label-for="reject"
              invalid-feedback="Reject Reason required"
            >
              <validation-provider
                #default="{ errors }"
                name="reject"
                rules="required"
              >
                <b-form-input
                  id="reject"
                  name="reject"
                  type="text"
                  v-model="reject_reason"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Reject Reason"
                  required="required"
                />
                <small class="text-danger">{{ errors[0] || errMessage }}</small>
              </validation-provider>
            </b-form-group>

            <b-row>
              <b-col>
                <b-button
                  class="mt-3"
                  type="submit"
                  variant="danger"
                  block
                  @click="reject()"
                >
                  Reject
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>
    </b-form>
  </b-container>
</template>

<script>
import {
  BModal,
  VBModal,
  BFormTextarea,
  BDropdownItem,
  BDropdown,
  BBadge,
  BPagination,
  BFormFile,
  BImg,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ImageUploader from "vue-image-upload-resize";
import { $themeConfig } from "@themeConfig";
import Cleave from "vue-cleave-component";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";

export default {
  components: {
    VueGoodTable,
    ToastificationContent,
    vSelect,
    ImageUploader,
    Cleave,
    BModal,
    BFormTextarea,
    BPagination,
    BBadge,
    BDropdownItem,
    BDropdown,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BImg,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      detail: {
        status: null,
        status_name: "",
        code: "",
        description: "",
        origin_id: null,
        origin: "",
        destination: "",
        reject_reason: "",
      },
      form: {
        qty: null,
        item_id: null,
      },
      form2: {
        selectedProduct: null,
        optionsProduct: [],
        qty: null,
        transfer_id: null,
      },
      reject_reason: "",
      storage_id: null,
      storage_qty: null,
      detail_id: null,
      code: "",
      name: "",
      unit_name: "",
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
        },
      },
      hasImage: "",
      image: "",
      photo: "",
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: "Image",
          field: "image",
        },
        {
          label: "Code",
          field: "code",
        },
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Qty",
          field: "qty",
        },
        {
          label: "Unit",
          field: "unit_name",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      permissions: [],
      rows: [],
      searchTerm: "",
      errors: "",
      errMessage: "",
    };
  },
  watch: {
    "form2.selectedProduct": function () {
      this.form2.qty = null;
    },
  },
  computed: {
    statusVariant() {
      const statusColor = {
        0: "light-warning",
        1: "light-info",
        2: "light-success",
        3: "light-danger",
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  setup() {
    // App Name
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  created() {
    this.getAllPermissions();
    this.getDetails();
    this.getDetailItems();
  },
  methods: {
    getAllPermissions() {
      this.permissions = sessionStorage.getItem("permissions");
    },
    getDetails() {
      const id = this.$route.params.id;
      this.$http.get("warehouse/transfer/" + id).then((response) => {
        // console.log(response.data.data)
        this.detail.status = response.data.data.status;
        this.detail.status_name = response.data.data.status_name;
        this.detail.code = response.data.data.code;
        if (response.data.data.description !== "") {
          this.detail.description = response.data.data.description;
        } else {
          this.detail.description = "-";
        }
        this.detail.origin_id = response.data.data.origin;
        this.detail.origin = response.data.data.warehouse_origin_name;
        this.detail.destination = response.data.data.warehouse_destination_name;
        this.detail.reject_reason = response.data.data.reject_reason;
        this.getProduct(this.detail.origin_id);
      });
    },
    getProduct($originID) {
      this.$http.get("warehouse/" + $originID + "/items").then((response) => {
        // console.log(response.data.data)
        this.form2.optionsProduct.splice(0);
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          const { baseUrl } = $themeConfig.app;
          this.photo = baseUrl;
          this.photo += "storage/product/";
          this.photo += datas[i].product_image;

          var $data = {
            value: datas[i].id,
            text: datas[i].product_name,
            code: datas[i].code,
            unit: datas[i].unit_name,
            urlImage: this.photo,
          };
          // console.log($data)
          this.form2.optionsProduct.push($data);
        }
        // console.log(this.form2.optionsProduct)
      });
    },
    getDetailItems() {
      const id = this.$route.params.id;
      this.$http.get("warehouse/transfer/" + id + "/items").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var storage_id = datas[i].id;
          var storage_qty = datas[i].qty;
          this.getWarehouseItem(datas[i].item_id, storage_id, storage_qty);
        }
      });
    },
    getWarehouseItem(id, storage_id, storage_qty) {
      this.$http.get("warehouse/item/" + id).then((response) => {
        // console.log(response.data.data)
        const { baseUrl } = $themeConfig.app;
        this.photo = baseUrl;
        this.photo += "storage/product/";
        var $data = {
          item_id: id,
          id: storage_id,
          qty: storage_qty,
          image: this.photo + response.data.data.product_image,
          code: response.data.data.code,
          name: response.data.data.product_name,
          unit_name: response.data.data.unit_name,
        };
        // console.log($data)
        this.rows.push($data);
        // console.log(this.rows)
      });
    },
    addTransferItem() {
      const id = this.$route.params.id;
      this.$refs["modal-add"].hide();
      if (this.form2.selectedProduct !== null) {
        var $item_id = this.form2.selectedProduct.value;
      }
      this.$http
        .post("warehouse/transfer/" + id + "/item/add", {
          item_id: $item_id,
          qty: this.form2.qty,
        })
        .then((response) => {
          // console.log(response.data.data)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Success add transfer item",
              variant: "success",
            },
          });
          location.reload();
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    updateTransferItem() {
      this.$http
        .post("warehouse/transfer/item/" + this.detail_id + "/update", {
          qty: this.form.qty,
          item_id: this.form.item_id,
        })
        .then((response) => {
          // console.log(response.data.data)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Success update transfer item",
              variant: "success",
            },
          });
          location.reload();
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    deleteTransferItem(id) {
      this.$http
        .post("warehouse/transfer/item/" + id + "/delete/")
        .then((response) => {
          // console.log(response.data.data)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "transfer item has been deleted",
              variant: "danger",
            },
          });
          location.reload();
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    trigger($id, $image, $code, $name, $unit_name, $qty, $item_id) {
      this.detail_id = $id;
      this.image = $image;
      this.code = $code;
      this.name = $name;
      this.unit_name = $unit_name;
      this.form.qty = $qty;
      this.form.item_id = $item_id;
    },
    submit() {
      const id = this.$route.params.id;
      this.$http
        .post("warehouse/transfer/" + id + "/submit")
        .then((response) => {
          // console.log(response.data.data)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Submitted",
              variant: "success",
            },
          });
          location.href = "/warehouse/transfer";
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    confirm() {
      const id = this.$route.params.id;
      this.$http
        .post("warehouse/transfer/" + id + "/confirm")
        .then((response) => {
          // console.log(response.data.data)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Confirmed",
              variant: "success",
            },
          });
          location.href = "/warehouse/transfer";
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    reject() {
      const id = this.$route.params.id;
      this.$http
        .post("warehouse/transfer/" + id + "/reject", {
          reject_reason: this.reject_reason,
        })
        .then((response) => {
          // console.log(response.data.data)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Rejected",
              variant: "danger",
            },
          });
          location.href = "/warehouse/transfer";
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>

<style>
#purchase div img.img-preview {
  width: 200px;
  padding-right: 10px;
}
</style>